"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormObserver = void 0;
const react_1 = require("react");
const formik_1 = require("formik");
const FormObserver = ({ onChange, }) => {
    const { values } = (0, formik_1.useFormikContext)();
    (0, react_1.useEffect)(() => {
        onChange(values);
    }, [values, onChange]);
    return null;
};
exports.FormObserver = FormObserver;
exports.default = exports.FormObserver;
